import i18n from '../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class AssignClerks extends BaseModel {
  pre_bids_lot_spacing = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    pre_bids_lot_spacing: 'min_value:0|required'
  };

  attributeLabels = {
    pre_bids_lot_spacing: i18n.t('Lot Spacing'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(AssignClerks);
